"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEntryPrefix = void 0;
var format_1 = __importDefault(require("date-fns/format"));
var log_constants_1 = require("../log.constants");
/**
 * Builds console message prefix with application name and timestamp
 */
function buildEntryPrefix(prefix, eventDate) {
    // date pattern apply
    var date = format_1.default(eventDate, log_constants_1.dateFormatPattern);
    // returns plain prefix
    return prefix + " - " + date;
}
exports.buildEntryPrefix = buildEntryPrefix;
//# sourceMappingURL=entry-prefix.js.map